// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  email: string;
  notificationID: string | number;
}

export function useUpdateEmailMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function updateEmail(params: paramsType): Promise<any> {
    const response = await api.post<any>(`account/changeemail/${params.email}`);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updateEmail,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
